type StatusBannerProps = {
    tone: 'success' | 'error'
    message: string
}

export const StatusBanner = ({ tone, message }: StatusBannerProps) => {
    const toneClass =
        tone === 'success'
            ? 'border-account-success-border bg-account-success-soft text-account-success'
            : 'border-account-error-border bg-account-error-soft text-account-error'

    return <div className={`rounded-xl border px-4 py-3 text-sm ${toneClass}`}>{message}</div>
}
